import { render, staticRenderFns } from "./mFooter.vue?vue&type=template&id=7a6e0fb4&scoped=true&"
import script from "./mFooter.vue?vue&type=script&lang=js&"
export * from "./mFooter.vue?vue&type=script&lang=js&"
import style0 from "./mFooter.vue?vue&type=style&index=0&id=7a6e0fb4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6e0fb4",
  null
  
)

export default component.exports